import { Sparkles } from 'lucide-react';
import SectionHeader from './SectionHeader';
import { PANCHANG_TRANSLATIONS } from "../../../../languages/panchang";

interface FestivalsProps {
    festivals: any[] | null;
    language: string;
}

const Festivals = ({ festivals, language }: FestivalsProps) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = PANCHANG_TRANSLATIONS[langKey];

    return (
        <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-6 md:p-8 shadow-xl">
            <SectionHeader icon={Sparkles} title={t.festivalsAndCelebrations} />
            {festivals && festivals.length > 0 ? (
                <div className="flex flex-wrap gap-3">
                    {festivals.map((festival: any, index: number) => (
                        <span
                            key={index}
                            className="px-4 py-2 bg-purple-600/20 border border-purple-500/40 rounded-full text-purple-200 font-medium font-sans hover:bg-purple-600/30 transition-colors"
                        >
                            {typeof festival === 'string' ? festival : festival.name}
                        </span>
                    ))}
                </div>
            ) : (
                <p className="text-purple-300/60 italic font-sans">
                    {t.noFestivals}
                </p>
            )}
        </div>
    );
};

export default Festivals;
